import gql from 'graphql-tag';

const query = gql`
  query PasswordIsSet {
    me {
      id
      passwordIsSet
    }
  }
`;

export default query;
